import { Box, Icon } from "@mui/material";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { registerParkingOnBallpark } from "store/slice/ballpark/ballparkSlice";

const RegisterBallparc = ({
  reservationId,
  onClose,
  setNotification,
  setReload,
  reload,
  title,
}) => {
  const [loading, setLoading] = useState(false);
  const [controller] = useMaterialUIController();

  const { sidenavColor } = controller;

  const dispatch = useDispatch();
  const handleRegister = async () => {
    setLoading(true);
    const response = await dispatch(
      registerParkingOnBallpark(reservationId)
    ).unwrap();

    if (response?.success) {
      setReload(!reload);
      onClose();
      setNotification({
        color: "success",
        title: "Success",
        content: response?.message,
        icon: "check",
        show: true,
      });
      setLoading(false);
    } else {
      setNotification({
        color: "error",
        title: "Error",
        content: response?.message,
        icon: "warning",
        show: true,
      });
      setLoading(false);
    }
  };
  return (
    <Box
      className="my-3"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <MDTypography variant="body2" className="text-center d-block mb-3">
        {title}
      </MDTypography>
      <MDButton
        variant="gradient"
        color={sidenavColor}
        onClick={handleRegister}
        disabled={loading}
        sx={{ minWidth: 180 }}
      >
        {loading ? "Processing..." : "Register on Ballpark"}
      </MDButton>
    </Box>
  );
};

export default RegisterBallparc;
